/* eslint-disable */
export default {
  createLog: '기록 만들기',
  creating: '만드는 중',
  save: '저장',
  saving: '저장 중',
  saved: '저장됨',
  view: '보기',
  creatingFailed: '만들지 못했습니다.',
  savingFailed: '저장하지 못했습니다.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
